/**
 * Branded header for customer-facing documents. This is usually the first
 * thing a customer sees of the business, so it mirrors the printed letterhead.
 */
export default function DocBrandBand({ label, company, meta }) {
  const c = company || {};
  return (
    <header className="brand-band">
      <div className="lbl">{label}</div>
      <div className="lh-row">
        {c.logoDataUrl ? <img src={c.logoDataUrl} alt="" /> : null}
        <div>
          <h1>{c.companyName}</h1>
          {c.address ? <div className="lh-line-lg">{c.address}</div> : null}
          {(c.phone || c.email) ? (
            <div className="lh-line-lg">{[c.phone, c.email].filter(Boolean).join(' · ')}</div>
          ) : null}
        </div>
      </div>
      {meta?.length ? (
        <dl className="meta">
          {meta.map((m, i) => (
            <div key={i} style={{ textAlign: i ? 'right' : 'left' }}>
              <dt className="lbl">{m.label}</dt>
              <dd className="v" style={{ margin: 0 }}>{m.value}</dd>
            </div>
          ))}
        </dl>
      ) : null}
    </header>
  );
}

/** Priced lines render as a row; unpriced ones are inclusion bullets. */
export function ScopeSections({ sections }) {
  return sections.map((s, i) => (
    <div key={i} style={{ marginTop: 'var(--s-4)' }}>
      <h3 className="nm">{s.name}</h3>
      <div style={{ marginTop: 'var(--s-1)' }}>
        {s.items.map((it, j) => it.amount > 0 ? (
          <div className="doc-line" key={j}>
            <span className="d">{it.description}</span>
            <span className="a">{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(it.amount)}</span>
          </div>
        ) : it.description ? (
          <p className="doc-bullet" key={j}>• {it.description}</p>
        ) : null)}
      </div>
    </div>
  ));
}
